import { DetailedPriceCoverageObject } from 'Api/insurance';
import {
  AkaStudentCoverage,
  AuroraCriticalIllnessCoverage,
  AuroraDisabilityTotalCoverage,
  BoatCoverage,
  CaravanCoverage,
  TravelCoverage,
} from 'Types/coverages/coverages.types';
import {
  DelkaskoBoatCoverages,
  ExtendedBoatCoverages,
  KaskoBoatCoverages,
  KaskoCaravanCoverages,
  StandardTravelCoverages,
  SuperTravelCoverages,
} from '../constants/coverages.constants';

export function isSuperTravelCoverage(coverage: string): boolean {
  return SuperTravelCoverages.includes(coverage as TravelCoverage);
}

export function isStandardTravelCoverage(coverage: string): boolean {
  return StandardTravelCoverages.includes(coverage as TravelCoverage);
}

export function isKaskoCaravanCoverage(coverage: string): boolean {
  return KaskoCaravanCoverages.includes(coverage as CaravanCoverage);
}

export const isExtendedBoatCoverage = (coverages: BoatCoverage[]): boolean =>
  coverages.some((coverage) => ExtendedBoatCoverages.includes(coverage));

export const isKaskoBoatCoverage = (coverages: BoatCoverage[]): boolean =>
  coverages.some((coverage) => KaskoBoatCoverages.includes(coverage));

export const isDelkaskoBoatCoverage = (coverages: BoatCoverage[]): boolean =>
  coverages.some((coverage) => DelkaskoBoatCoverages.includes(coverage));

export function isFireTheftCaravanCoverage(coverage: string): boolean {
  return CaravanCoverage.FIRE_AND_THEFT === coverage;
}

export const isAkaStudentOutsideNordicCountries = (coverage: string): boolean =>
  coverage === AkaStudentCoverage.TRAVEL_SUPER_EUROPE ||
  coverage === AkaStudentCoverage.TRAVEL_SUPER_AUSTRALIA ||
  coverage === AkaStudentCoverage.TRAVEL_SUPER_USA ||
  coverage === AkaStudentCoverage.TRAVEL_SUPER_OTHER_COUNTRIES;

export const isAuroraDisabilityTotalCoverage = (
  coverages: DetailedPriceCoverageObject[],
): boolean =>
  coverages.some(
    ({ coverage }) =>
      coverage === AuroraDisabilityTotalCoverage.TOTAL_UTKN ||
      coverage === AuroraDisabilityTotalCoverage.TOTAL_UTKN_SMOKER ||
      coverage === AuroraDisabilityTotalCoverage.TOTAL_UKFK_MAN ||
      coverage === AuroraDisabilityTotalCoverage.TOTAL_UKFK_WOMAN,
  );

export const isAuroraDisabilityTotalBasisCoverage = (
  coverages: DetailedPriceCoverageObject[],
): boolean =>
  coverages.some(
    ({ coverage }) =>
      coverage === AuroraDisabilityTotalCoverage.BASIS_UKFB_MAN ||
      coverage === AuroraDisabilityTotalCoverage.BASIS_UKFB_WOMAN,
  );

export const isAuroraDisabilityTotalWorkCoverage = (
  coverages: DetailedPriceCoverageObject[],
): boolean =>
  coverages.some(
    ({ coverage }) =>
      coverage === AuroraDisabilityTotalCoverage.INCAPACITY_OF_WORK_UKF_MAN ||
      coverage === AuroraDisabilityTotalCoverage.INCAPACITY_OF_WORK_UKF_WOMAN,
  );

export const isAuroraCriticalIllnessTripleCoverage = (
  coverages: DetailedPriceCoverageObject[],
): boolean =>
  coverages.some(
    ({ coverage }) => coverage === AuroraCriticalIllnessCoverage.TRIPLE,
  );
